import {call, put, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {requestJobAsync, requestJobsAsync} from "../AsyncActions/jobs.async";
import {saveJob, saveJobs} from "../Actions/jobs.action";
import {toast} from "react-toastify";

function* getJobs(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(requestJobsAsync, pageUrl);
    if (response?.data) {
      yield put(saveJobs(response?.data));
    }
  } catch (e) {
    toast.error(e);
  }
}

function* getJob(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(requestJobAsync, {id: payload});
    if (response?.data?.data) {
      yield put(saveJob(response?.data?.data));
    }
  } catch (e) {
    toast.error(e);
  }
}

export function* jobsSaga() {
  yield takeLatest(actions.REQUEST_JOBS, getJobs);
  yield takeLatest(actions.REQUEST_JOB, getJob);
}
